export default __webpack_public_path__ + "static/aeb2ebd188c43d3ecbeac0dd3dcd7f8b.png";